import * as React from 'react'
import { Button, Container, Spinner, Image, Form, Tabs, Tab, Col, Row } from 'react-bootstrap'
import * as _ from 'lodash'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import {  AxiosInstance, uploadFileServer } from '../../utils/RequestMethods'
import config from '../../constants/config'
import images from '../../constants/images'
import { useParams } from 'react-router-dom'
import { ClientT, UserT } from '../../types/Users'

import InputPhone from '../../components/InputPhone'
import FormStripe from '../../components/FormStripe/FormStripe'
import ClientPayments from './ClientPayments'
import ButtonLoading from '../../components/ButtonLoading/ButtonLoading'
import { copyObject } from '../../utils'

import ButtonUploadImage from '../../components/ButtonUploadImage'
import GoogleMapAutoComplete from '../../components/MapBoxAutoComplete/GoogleMapAutoComplete'






const ItemInline = ({ label, value }) => {
    return (
        <p style={{}}>
            <span style={{ fontWeight: "bold" }}> {label} </span>
            <span className="">
                <Form.Control value={value} className="input-material" />
            </span>
        </p>
    )
}
export interface IClientProfileProps {

}

const ClientProfile: React.FC<IClientProfileProps> = ({ }) => {

    const history = useHistory()
    const [markers, setMarkers] = React.useState([])
    const [client, setClient] = React.useState(null)
    const { id } = useParams()
    const [isReady, setIsReady] = React.useState(false)
    const [showAlertDelete, setShowAlertDelete] = React.useState(false);

    const [dirty, setDirty] = React.useState({})
    const [fetchIsError, setFetchIsError] = React.useState(false);
    const [fileProfilePic, setFileProfilePic] = React.useState(null)
    React.useEffect(() => {
        getClientFromDB()
    }, [])


    const getClientFromDB = async (): Promise<void> => {
        const params = {
            
        }
        let options={
          data:params
        }
        AxiosInstance.get(`${config.url.clients}/${id}`, options).then((res) => {
            if (res && res.data && res.status == 200) {
                setClient(res.data)
                setIsReady(true)
            }

        }).catch((error) => {
            console.log("error" + error)
        })
    }




    const save = async (params = null): Promise<string> => {
        if (!params) {
            params = { ...dirty }
        }
        console.log('params', params)
        console.log('params', dirty)
        try {
            let res = await AxiosInstance.post(`${config.url.clients}/${client.id}`, params)
            if (res && res.data) {
                setClient(res.data)
                return 'Client saved.'
            }
        } catch (error) {
            console.log('FALSE: ', error) // TODO - Implement elegant error handling / feedback to user here
            throw new Error(error)

        }
    }
    const goToClients = (): void => {
        history.push({
            pathname: `/clients`
        })
    }
    /**
      *
      * @returns
      */
    const deleteClient = async (): Promise<string> => {
        let url = `${config.url.clients}/${id}`
        try {

            let res = await AxiosInstance.delete(url)
            if (res && res.data) {
                setTimeout(() => {
                    goToClients()
                }, 1000);
                return "Client deleted."
            }
            throw "Client deletion failed.";
        } catch (error) {
            throw error;

        }
    }

    const onChangeFields = (key: string, value: any) => {
        let cloneDirty = copyObject(dirty)
        cloneDirty[key] = value
        setDirty(cloneDirty)
    }


    const saveProfilePicture = async (event): Promise<string> => {
        try {
            const res = await uploadFileServer(fileProfilePic)
            if (res.source_url) {
                onChangeFields('profilePic', res.source_url)
                let params = {
                    profilePic: res.source_url
                }
                const resSave = await save(params)
                if (resSave) {
                    setTimeout(() => {
                        setFileProfilePic(null)
                    }, 1000);
                    return "Profile Pic saved."
                }
            }
        } catch (error) {
            throw new Error(error)
        }
    }

    if (!isReady) {
        return (
            <Container className="mt-5 ">
                <div className="d-flex flex-column align-items-center justify-content-center">
                    <span>Loading...</span>
                    <Spinner animation="border" variant="success" />
                </div>
            </Container>
        )
    }
    return (
        <div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 3fr' }}>
                <div>
                    <Image
                        src={fileProfilePic && fileProfilePic.uri ? fileProfilePic.uri : client.profilePic != '' ? client.profilePic : images.noProfilePic}
                        style={{ width: 200, height: 200 }} />
                    <br />

                    <ButtonUploadImage
                        type="button"

                        accept={"image/png, image/jpeg"}
                        className="btn-link  mt-2"
                        onChangeFile={(file) => {
                            setFileProfilePic(file)
                        }}>
                        Edit Profile Image
                    </ButtonUploadImage>
                    {fileProfilePic && <div>
                        <Button variant="light"
                            onClick={() => {
                                setFileProfilePic(null)
                            }}>
                            Cancel</Button>
                        <ButtonLoading
                            className="btn-primary"
                            onClickFetching={saveProfilePicture}>
                            Save</ButtonLoading>
                    </div>}

                </div>
                <div className="card-body">

                    <div>
                        <Row>
                            <Form.Group as={Col} controlId="firstname">
                                <Form.Control
                                    className='input-material'
                                    onChange={(event: any) => { onChangeFields('firstName', event.target.value) }}
                                    placeholder='First Name'
                                    style={{ fontSize: 33 }}

                                    value={`${_.has(dirty, "firstName") ? dirty['firstName'] : client.firstName}`} />
                            </Form.Group>
                            <Form.Group as={Col} controlId="lastname">
                                <Form.Control
                                    className='input-material'
                                    onChange={(event: any) => { onChangeFields('lastName', event.target.value) }}
                                    placeholder='Last Name'
                                    style={{ fontSize: 33 }}

                                    value={`${_.has(dirty, "lastName") ? dirty['lastName'] : client.lastName}`} />
                            </Form.Group>
                        </Row>
                        <Row>
                            <Form.Group as={Col} controlId="phone">
                                <InputPhone
                                    numberFormat={true}
                                    placeholder='Phone'
                                    className="input-material"

                                    defaultValue={`${_.has(dirty, "phone") ? dirty['phone'] : client.phone}`}
                                    value={`${_.has(dirty, "phone") ? dirty['phone'] : client.phone}`}

                                    onChangePhone={val => {
                                        onChangeFields('phone', val)
                                    }}
                                    onChangeValue={val => {
                                        // console.log("val", val)
                                        // changeTextInput('phone', val)
                                    }} />

                            </Form.Group>

                            <Form.Group as={Col} controlId="email">
                                <Form.Control
                                    className='input-material'
                                    onChange={(event: any) => { onChangeFields('email', event.target.value) }}
                                    placeholder='Email'
                                    value={`${_.has(dirty, "email") ? dirty['email'] : client.email}`} />
                            </Form.Group>
                        </Row>

                        <Row>
                            <Form.Group as={Col} controlId="address">
                                <GoogleMapAutoComplete
                                    idAddresss="address_From"
                                    className='input-material'
                                    apiKey={config.keyMap}
                                    onChangeText={text => { }}
                                    onPress={async location => {
                                        // let w = { ...worker }
                                        // w.address = location.verbose_address
                                        onChangeFields('address', location.verbose_address)
                                    }}

                                    placeholder='Address'
                                    textValue={`${_.has(dirty, "address") ? dirty['address'] : client.address}`}
                                />


                            </Form.Group>
                            <Form.Group as={Col} controlId="address2">

                                <Form.Control
                                    className='input-material'
                                    onChange={(event: any) => { onChangeFields('address2', event.target.value) }}
                                    placeholder='Unit'
                                    value={`${_.has(dirty, "address2") ? dirty['address2'] : client.address2}`} />
                            </Form.Group>
                        </Row>
                        {/* <ItemInline label={"First Name:"} value={client.firstName} />
                        <ItemInline label={"Last Name:"} value={client.lastName} /> */}
                        {/* <ItemInline label={"Email:"} value={client.email} /> */}
                        {/* <p style={{}}>
                            <span style={{ fontWeight: "bold" }}>Phone: </span>
                            <span className="">
                                <InputPhone
                                    className="input-material"
                                    defaultValue={`${client.phone}`}
                                    value={`${client.phone}`}
                                    onChangeValue={val => { }} />
                            </span>
                        </p> */}



                        {/* <ItemInline label={"Address:"} value={client.address} /> */}
                        <div>
                            {(client.clientJobs.length <= 0 && showAlertDelete) && <div className="alert alert-danger d-flex flex-column">

                                <span>Are you sure you want to delete this client?</span>
                                <div className=" d-flex flex-row">
                                    <Button variant="light" onClick={() => { setShowAlertDelete(false) }}>Cancel</Button>
                                    <ButtonLoading
                                        type="button"

                                        onClickFetching={deleteClient}
                                        className="btn-outline-danger ">Delete Client</ButtonLoading>
                                </div>

                            </div>}
                            <div className="d-flex flex-row mt-2">
                                <ButtonLoading
                                    style={{ marginLeft: 0 }}
                                    className="btn-success"
                                    onClickFetching={async (e): Promise<string> => {
                                        return await save()
                                    }}>Save</ButtonLoading>

                                {client.clientJobs.length <= 0 && <Button variant="outline-danger" disabled={showAlertDelete} onClick={() => { setShowAlertDelete(true) }}>Delete Client</Button>}
                            </div>
                        </div>

                    </div>

                    {/* <div className="">
                        <h3>Payment Information</h3>
                        <ClientPayments client={client} />
                    </div> */}
                </div>


            </div>

        </div>



    );
}
export default ClientProfile;
export { ClientProfile };
